import goto from "src/pageDefinitions/goto";
import { trackEvent } from "src/utils/api/tracker";
import { useOnce } from "./lifecycle";
import { useServerContext } from "./redux";

export function pathIsInSubscriptionCancelContext(path: string) {
  const subscriptionContextRegex = /\/subscription\/(hm\/)?(trial-)?cancel/;
  return subscriptionContextRegex.test(path);
}

export function isInCorrectSubscriptionContext(
  isHM: boolean,
  isInTrial: boolean,
  path: string
) {
  if (!pathIsInSubscriptionCancelContext(path)) {
    return false;
  }
  const isHMPath = path.includes("/hm");
  const isTrialPath = path.includes("trial-cancel");

  return isHM === isHMPath && isInTrial === isTrialPath;
}

export function useLegacyCounterOfferContextRedirect() {
  const serverContext = useServerContext();

  return useOnce(() => {
    trackEvent("RedirectLegacyCounterOffer", {
      isInTrial: serverContext.is_in_trial,
      isHM: serverContext.subscription_is_hm,
    });
    goto.cancelSubscription(
      serverContext.subscription_is_hm,
      serverContext.is_in_trial
    );
  });
}
